import { Stack, Tooltip } from "@mantine/core"
import { IconShield } from "@tabler/icons-react"
import { useTranslation } from "react-i18next"

import { OEKO_TEX_API_URL } from "../config"

type ManualCheckIconProps = {
  reference: string
}

export function ManualCheckIcon({ reference }: ManualCheckIconProps) {
  const { t } = useTranslation("certificates")

  return (
    <Stack align="center">
      <Tooltip label={t("modal.labels.manualCheck")} fz="xs">
        <IconShield
          size={16}
          cursor="pointer"
          onClick={() => window.open(OEKO_TEX_API_URL + reference)}
        />
      </Tooltip>
    </Stack>
  )
}
